import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../hooks/reduxHooks";
import { saveDesignName } from "../../../api/save-design.api";
import { useParams } from "react-router-dom";
import { updateDesignName } from "../../../store/slices/viewSlice";
import { toast } from "react-toastify"; // Import toast components

const RenameProject = ({ oldName, showRenamePopup }: any) => {
  const designName = useAppSelector((state: any) => state.canvases.designName);
  const [newDesignName, setNewDesignName] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const { designId } = useParams(); // Extract `designId` from the URL
  const dispatch = useAppDispatch();

  useEffect(() => {
    setNewDesignName(designName);
  }, [designName]);

  const saveNewDesignName = (e: any) => {
    setIsSaving(true);
    saveDesignName(
      designId as any,
      {
        newName: newDesignName,
      } as any
    ).then(
      (res) => {
        dispatch(updateDesignName(newDesignName));
        toast.success("Design saved successfully!");
        setIsSaving(false);

        showRenamePopup(false);
      },
      (error) => {
        setIsSaving(false);
        toast.error("Error saving design");
      }
    );

    console.log(e.target.value);
  };

  return (
    <div className="text-center px-5">
      <div className="text-2xl font-bold mb-2">Rename Your Design</div>
      <div className="text-grey mb-5">
        Rename your design and we'll save it .
      </div>
      <div className="my-4">
        <input
          className="border border-solid border-[#939393] block mx-auto w-full max-w-[440px] p-2 rounded-md mb-3"
          type="text"
          placeholder="Enter Your New Project Name Here...."
          defaultValue={designName}
          value={newDesignName}
          onChange={(e) => setNewDesignName(e.target.value)}
          maxLength={25}
        />
        <div className="text-xs text-grey italic">
          25 characters max, no symbols except dashes
        </div>
      </div>
      <button
        onClick={saveNewDesignName}
        className="max-sm:w-full w-[50%] text-center block bg-primaryred text-white font-bold	text-xl py-2 px-7 rounded-full mx-auto my-4"
      >
        {isSaving ? "Saving.." : "Rename Design 👉🏻"}
      </button>
    </div>
  );
};
export default RenameProject;
